module.exports = __webpack_public_path__ + "static/media/20_000016.9d87380e.jpg";